import { binarySelectOptions, useRouter } from '@application/utils';
import { Container } from '@presentation/components/Container';
import { useTranslation } from '@presentation/utils';
import { ClassNames, useTheme } from '@emotion/react';
import { Formik } from 'formik';
import type { FC } from 'react';
import { InputCheckboxField } from '../InputCheckboxField';
import * as Styled from './styled';
import type { PromoNewsletterFormValues, PromoNewsletterProps } from './types';
import { InputLabel } from '../InputLabel';
import { InputRadioField } from '../InputRadioField';
import { InputField } from '../InputField';

export * from './types';

export const PromoNewsletter: FC<PromoNewsletterProps> = (props) => {
  const { form, ...rest } = props;
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();
  const yesNoOptions = binarySelectOptions(translate);
  const theme = useTheme();

  return (
    <Styled.Background>
      <Container>
        <Styled.Content {...rest}>
          <Styled.Title>{translate('common.sections.newsletter.title')}</Styled.Title>
          <Styled.Subtitle>{translate('common.sections.newsletter.subtitle')}</Styled.Subtitle>

          <Formik<PromoNewsletterFormValues> {...form}>
            {({ submitForm, errors, isSubmitting }) => (
              <>
                <Styled.InputWrapper>
                  <InputLabel required color="light">
                    {translate('common.inputs.email.label')}
                  </InputLabel>
                  <InputField
                    placeholder={translate('common.inputs.email.placeholder')}
                    name="email"
                    type="email"
                  />
                </Styled.InputWrapper>
                <Styled.InputWrapper>
                  <InputLabel required color="light">
                    {translate('common.inputs.hasADog')}
                  </InputLabel>
                  <ClassNames>
                    {({ css: classNameCss }) => {
                      const wrapperClassname = classNameCss(Styled.inputRadioWrapperStyle(theme));

                      return (
                        <InputRadioField<boolean>
                          name="hasADog"
                          variant="blue"
                          grow
                          options={yesNoOptions}
                          hasError={!!errors.hasADog}
                          wrapperClass={wrapperClassname}
                        />
                      );
                    }}
                  </ClassNames>
                </Styled.InputWrapper>
                <Styled.CheckboxWrapper>
                  <InputCheckboxField name="marketingEmailConsent">
                    <Styled.TermsContainer
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: translate('common.inputs.termsPolicyEmailMarketing.label').replace(
                          '$link',
                          routeLocationDescriptor('privacy').pathname ?? '',
                        ),
                      }}
                    />
                  </InputCheckboxField>
                </Styled.CheckboxWrapper>
                <Styled.InputWrapper>
                  <Styled.ButtonStyled
                    color="white"
                    onClick={submitForm}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                  >
                    {translate('common.buttons.iRegister')}
                  </Styled.ButtonStyled>
                </Styled.InputWrapper>
              </>
            )}
          </Formik>
        </Styled.Content>
      </Container>
    </Styled.Background>
  );
};
